var map = {
	"./Blogs/Blog1.png": 750,
	"./Blogs/Blog10.png": 751,
	"./Blogs/Blog11.png": 752,
	"./Blogs/Blog12.1.png": 753,
	"./Blogs/Blog12.10.png": 754,
	"./Blogs/Blog12.11.png": 755,
	"./Blogs/Blog12.12.png": 756,
	"./Blogs/Blog12.13.png": 757,
	"./Blogs/Blog12.14.png": 758,
	"./Blogs/Blog12.15.png": 759,
	"./Blogs/Blog12.16.png": 760,
	"./Blogs/Blog12.17.png": 761,
	"./Blogs/Blog12.2.png": 762,
	"./Blogs/Blog12.3.png": 763,
	"./Blogs/Blog12.4.png": 764,
	"./Blogs/Blog12.5.png": 765,
	"./Blogs/Blog12.6.png": 766,
	"./Blogs/Blog12.7.png": 767,
	"./Blogs/Blog12.8.png": 768,
	"./Blogs/Blog12.9.png": 769,
	"./Blogs/Blog12.png": 770,
	"./Blogs/Blog2.png": 771,
	"./Blogs/Blog23.jpg": 772,
	"./Blogs/Blog233.jpg": 773,
	"./Blogs/Blog3.png": 774,
	"./Blogs/Blog4.png": 775,
	"./Blogs/Blog5.png": 776,
	"./Blogs/Blog6.png": 777,
	"./Blogs/Blog7.png": 778,
	"./Blogs/Blog8.png": 779,
	"./Blogs/Blog9.png": 780,
	"./Blogs/Chaithanya.jpeg": 781,
	"./Blogs/Chinmayi.svg": 782,
	"./Blogs/Deeksha.svg": 783,
	"./Blogs/Rectangle.jpg": 784,
	"./Blogs/Rectangle1.jpg": 785,
	"./Blogs/Rectangle2.jpg": 786,
	"./Blogs/Rectangle23.jpg": 247,
	"./Blogs/Rectangle3.jpg": 787,
	"./Blogs/b17.svg": 788,
	"./Blogs/b18.jpg": 248,
	"./Blogs/b18.svg": 789,
	"./Blogs/b19.jpg": 249,
	"./Blogs/b19.svg": 790,
	"./Blogs/b20.jpg": 250,
	"./Blogs/b20.svg": 791,
	"./Blogs/b21.svg": 792,
	"./Blogs/blog-1.jpg": 251,
	"./Blogs/blog-1.svg": 793,
	"./Blogs/blog-10.svg": 794,
	"./Blogs/blog-11.svg": 795,
	"./Blogs/blog-12.jpg": 252,
	"./Blogs/blog-12.svg": 796,
	"./Blogs/blog-13(graph).svg": 253,
	"./Blogs/blog-13.jpg": 254,
	"./Blogs/blog-13.svg": 797,
	"./Blogs/blog-2.jpg": 255,
	"./Blogs/blog-2.svg": 798,
	"./Blogs/blog-29-image-1.webp": 256,
	"./Blogs/blog-29-image-2.webp": 257,
	"./Blogs/blog-2a.jpg": 258,
	"./Blogs/blog-3.jpg": 259,
	"./Blogs/blog-3.svg": 799,
	"./Blogs/blog-30-thumbnail.png": 800,
	"./Blogs/blog-30.webp": 260,
	"./Blogs/blog-31-image-1.jpg": 261,
	"./Blogs/blog-31-image-2.jpg": 262,
	"./Blogs/blog-32-image-1.jpg": 263,
	"./Blogs/blog-32-image-2.jpg": 264,
	"./Blogs/blog-33-image-1.jpg": 265,
	"./Blogs/blog-33-image-2.webp": 266,
	"./Blogs/blog-33-image-3.jpg": 267,
	"./Blogs/blog-33-image-4.jpg": 268,
	"./Blogs/blog-33-image-5.jpg": 269,
	"./Blogs/blog-34-image-1.jpg": 270,
	"./Blogs/blog-34-image-2.jpg": 271,
	"./Blogs/blog-34-image-3.jpg": 272,
	"./Blogs/blog-34-image-4.jpg": 273,
	"./Blogs/blog-34-image-5.jpg": 274,
	"./Blogs/blog-35-img1.webp": 275,
	"./Blogs/blog-35-img2.webp": 276,
	"./Blogs/blog-35-img3.webp": 277,
	"./Blogs/blog-36-img1.jpg": 278,
	"./Blogs/blog-36-img2.webp": 801,
	"./Blogs/blog-36-img3.webp": 279,
	"./Blogs/blog-36-img4.webp": 280,
	"./Blogs/blog-37-img1.webp": 281,
	"./Blogs/blog-37-img2.webp": 802,
	"./Blogs/blog-37-img3.webp": 803,
	"./Blogs/blog-37-img4.webp": 804,
	"./Blogs/blog-37-img5.webp": 805,
	"./Blogs/blog-38.webp": 282,
	"./Blogs/blog-39-1.png": 806,
	"./Blogs/blog-39-1.webp": 807,
	"./Blogs/blog-39-2.jpg": 808,
	"./Blogs/blog-39-2.png": 809,
	"./Blogs/blog-39-3.png": 810,
	"./Blogs/blog-39-4.png": 811,
	"./Blogs/blog-39-5.png": 812,
	"./Blogs/blog-39-6.png": 813,
	"./Blogs/blog-39-7.png": 814,
	"./Blogs/blog-3a.jpg": 283,
	"./Blogs/blog-4.jpg": 284,
	"./Blogs/blog-4.svg": 285,
	"./Blogs/blog-40-1.jpg": 815,
	"./Blogs/blog-40-1.webp": 816,
	"./Blogs/blog-40-2.webp": 817,
	"./Blogs/blog-40-3.webp": 818,
	"./Blogs/blog-40-4.webp": 819,
	"./Blogs/blog-41-1.png": 820,
	"./Blogs/blog-41-1.webp": 821,
	"./Blogs/blog-41-2.webp": 822,
	"./Blogs/blog-42-1.jpg": 823,
	"./Blogs/blog-42-1.webp": 824,
	"./Blogs/blog-42-2.webp": 825,
	"./Blogs/blog-43-1.jpg": 826,
	"./Blogs/blog-43-2.webp": 827,
	"./Blogs/blog-43-3.webp": 828,
	"./Blogs/blog-45.webp": 829,
	"./Blogs/blog-46.webp": 830,
	"./Blogs/blog-47.webp": 831,
	"./Blogs/blog-48.webp": 832,
	"./Blogs/blog-49.webp": 833,
	"./Blogs/blog-5.svg": 834,
	"./Blogs/blog-6.jpg": 286,
	"./Blogs/blog-6.svg": 835,
	"./Blogs/blog-7.jpg": 287,
	"./Blogs/blog-7.svg": 836,
	"./Blogs/blog-8.jpg": 288,
	"./Blogs/blog-8.svg": 837,
	"./Blogs/blog-8a.jpg": 289,
	"./Blogs/blog-9.jpg": 838,
	"./Blogs/blog-9.svg": 839,
	"./Blogs/blog14.jpg": 290,
	"./Blogs/blog14.svg": 840,
	"./Blogs/blog15.jpg": 291,
	"./Blogs/blog15.svg": 841,
	"./Blogs/blog16.jpeg": 842,
	"./Blogs/blog16.jpg": 292,
	"./Blogs/blog16.svg": 843,
	"./Blogs/blog17.jpg": 293,
	"./Blogs/blog17.svg": 844,
	"./Blogs/blog177.svg": 845,
	"./Blogs/blog18.jpg": 846,
	"./Blogs/blog24.jpg": 294,
	"./Blogs/blog25.jpg": 295,
	"./Blogs/blog26.webp": 296,
	"./Blogs/blog27.webp": 297,
	"./Blogs/blog28-1.webp": 298,
	"./Blogs/blog28-2.webp": 299,
	"./Blogs/blog28-3.webp": 300,
	"./Blogs/blog_44.webp": 847,
	"./Blogs/blog_51.webp": 848,
	"./Blogs/blog_52.webp": 849,
	"./Blogs/blog_53.webp": 850,
	"./Blogs/blog_54.webp": 851,
	"./Blogs/blog_55.webp": 852,
	"./Blogs/blog_56.webp": 853,
	"./Blogs/blog_57.webp": 854,
	"./Blogs/blog_58.webp": 855,
	"./Blogs/blog_59.webp": 856,
	"./Blogs/blog_60.webp": 857,
	"./Blogs/carbon-accounting-1.png": 858,
	"./Blogs/carbon_accounting.webp": 859,
	"./Blogs/cluster_1.webp": 860,
	"./Blogs/cluster_10.webp": 861,
	"./Blogs/cluster_2.webp": 862,
	"./Blogs/cluster_3.webp": 863,
	"./Blogs/cluster_4.webp": 864,
	"./Blogs/cluster_5.webp": 865,
	"./Blogs/cluster_6.webp": 866,
	"./Blogs/cluster_7.webp": 867,
	"./Blogs/cluster_8.jpg": 868,
	"./Blogs/cluster_9.webp": 869,
	"./Blogs/esg-img.jpg": 301,
	"./Blogs/esg-report.jpg": 870,
	"./Blogs/giftboxes.jpg": 302,
	"./Blogs/giftboxes.svg": 871,
	"./Blogs/handImg.jpg": 872,
	"./Blogs/letterbox.svg": 168,
	"./Blogs/piller_0.webp": 873,
	"./Blogs/podcast-2.jpg": 874,
	"./Blogs/podcast-theme.jpg": 875,
	"./Blogs/rahul.svg": 876,
	"./Blogs/updapt-esg-all-in-one.png": 877,
	"./Blogs5/Blog1.png": 1246,
	"./Blogs5/Blog10.png": 1247,
	"./Blogs5/Blog11.png": 1248,
	"./Blogs5/Blog12.1.png": 1249,
	"./Blogs5/Blog12.10.png": 1250,
	"./Blogs5/Blog12.11.png": 1251,
	"./Blogs5/Blog12.12.png": 1252,
	"./Blogs5/Blog12.13.png": 1253,
	"./Blogs5/Blog12.14.png": 1254,
	"./Blogs5/Blog12.15.png": 1255,
	"./Blogs5/Blog12.16.png": 1256,
	"./Blogs5/Blog12.17.png": 1257,
	"./Blogs5/Blog12.2.png": 1258,
	"./Blogs5/Blog12.3.png": 1259,
	"./Blogs5/Blog12.4.png": 1260,
	"./Blogs5/Blog12.5.png": 1261,
	"./Blogs5/Blog12.6.png": 1262,
	"./Blogs5/Blog12.7.png": 1263,
	"./Blogs5/Blog12.8.png": 1264,
	"./Blogs5/Blog12.9.png": 1265,
	"./Blogs5/Blog12.png": 1266,
	"./Blogs5/Blog2.png": 1267,
	"./Blogs5/Blog3.png": 1268,
	"./Blogs5/Blog4.png": 1269,
	"./Blogs5/Blog5.png": 1270,
	"./Blogs5/Blog6.png": 1271,
	"./Blogs5/Blog7.png": 1272,
	"./Blogs5/Blog8.png": 1273,
	"./Blogs5/Blog9.png": 1274,
	"./Blogs5/Chaithanya.jpeg": 1275,
	"./Blogs5/Chinmayi.svg": 1276,
	"./Blogs5/Deeksha.svg": 1277,
	"./Blogs5/Image-1.jpg": 1278,
	"./Blogs5/Image-10.jpg": 1279,
	"./Blogs5/Image-11.jpg": 1280,
	"./Blogs5/Image-12.jpg": 1281,
	"./Blogs5/Image-13.jpg": 1282,
	"./Blogs5/Image-14.jpg": 1283,
	"./Blogs5/Image-15.jpg": 1284,
	"./Blogs5/Image-16.jpg": 1285,
	"./Blogs5/Image-17.jpg": 1286,
	"./Blogs5/Image-18.jpg": 1287,
	"./Blogs5/Image-19.jpg": 1288,
	"./Blogs5/Image-2.jpg": 1289,
	"./Blogs5/Image-20.jpg": 1290,
	"./Blogs5/Image-21.jpg": 1291,
	"./Blogs5/Image-21.svg": 1292,
	"./Blogs5/Image-3.jpg": 1293,
	"./Blogs5/Image-4.jpg": 1294,
	"./Blogs5/Image-5.jpg": 1295,
	"./Blogs5/Image-6.jpg": 1296,
	"./Blogs5/Image-7.jpg": 1297,
	"./Blogs5/Image-8.jpg": 1298,
	"./Blogs5/Image-9.jpg": 1299,
	"./Blogs5/UAE.jpg": 1300,
	"./Blogs5/b17.svg": 1301,
	"./Blogs5/b18.svg": 1302,
	"./Blogs5/b19.svg": 1303,
	"./Blogs5/blog-1.jpg": 1304,
	"./Blogs5/blog-1.svg": 1305,
	"./Blogs5/blog-10.svg": 1306,
	"./Blogs5/blog-11.svg": 1307,
	"./Blogs5/blog-12.jpg": 1308,
	"./Blogs5/blog-12.svg": 1309,
	"./Blogs5/blog-13(graph).svg": 1310,
	"./Blogs5/blog-13.jpg": 1311,
	"./Blogs5/blog-13.svg": 1312,
	"./Blogs5/blog-2.jpg": 1313,
	"./Blogs5/blog-2.svg": 1314,
	"./Blogs5/blog-3.jpg": 1315,
	"./Blogs5/blog-3.svg": 1316,
	"./Blogs5/blog-4.svg": 1317,
	"./Blogs5/blog-5.svg": 1318,
	"./Blogs5/blog-6.svg": 1319,
	"./Blogs5/blog-7.svg": 1320,
	"./Blogs5/blog-8.svg": 1321,
	"./Blogs5/blog-9.svg": 1322,
	"./Blogs5/blog14.jpg": 1323,
	"./Blogs5/blog14.svg": 1324,
	"./Blogs5/blog15.jpg": 1325,
	"./Blogs5/blog15.svg": 1326,
	"./Blogs5/blog16.jpeg": 1327,
	"./Blogs5/blog16.svg": 1328,
	"./Blogs5/blog17.jpg": 1329,
	"./Blogs5/blog177.svg": 1330,
	"./Blogs5/blog18.jpg": 1331,
	"./Blogs5/esg-report.jpg": 1332,
	"./Blogs5/image18.jpg": 1333,
	"./Blogs5/letterbox.svg": 1334,
	"./Blogs5/media-01.jpg": 1335,
	"./Blogs5/rahul.svg": 1336,
	"./Blogs5/seo-blog17.jpg": 1337,
	"./FooterImages/demo-background.svg": 598,
	"./FooterImages/duns-number.png": 1338,
	"./FooterImages/duns-number.svg": 685,
	"./FooterImages/facebook.svg": 675,
	"./FooterImages/gdpr-icon.svg": 683,
	"./FooterImages/hover-facebook.svg": 676,
	"./FooterImages/hover-instagram.svg": 678,
	"./FooterImages/hover-linkedin.svg": 680,
	"./FooterImages/hover-twitter.svg": 681,
	"./FooterImages/instagram.svg": 677,
	"./FooterImages/iso-icon.svg": 684,
	"./FooterImages/linkedin.svg": 679,
	"./FooterImages/spinner.gif": 511,
	"./FooterImages/twitter.svg": 682,
	"./Header/blogs.svg": 673,
	"./Header/dataManagementCover.svg": 661,
	"./Header/erm-logo.svg": 667,
	"./Header/logo-analytics.svg": 664,
	"./Header/logo-data-management.svg": 663,
	"./Header/logo-grant-management.svg": 665,
	"./Header/logo-green.png": 1339,
	"./Header/logo-green.svg": 565,
	"./Header/logo-reporting.svg": 662,
	"./Header/logo-white.svg": 566,
	"./Header/media_icon.svg": 671,
	"./Header/newLogo.svg": 564,
	"./Header/newsletter.svg": 670,
	"./Header/newsroom_icon.svg": 672,
	"./Header/nz-logo.svg": 666,
	"./Header/pa-logo.svg": 669,
	"./Header/scm-logo.svg": 668,
	"./Header/updapt-logo-green.png": 59,
	"./Header/updapt-logo-white.png": 60,
	"./Home/Banner/1.svg": 600,
	"./Home/Banner/2.svg": 601,
	"./Home/Banner/3.svg": 602,
	"./Home/Banner/4.svg": 603,
	"./Home/Banner/5.svg": 604,
	"./Home/accenture__ciie.svg": 610,
	"./Home/accenture_logo.PNG": 1340,
	"./Home/accentureciie.png": 1341,
	"./Home/analytics.gif": 1342,
	"./Home/analytics.mp4": 1343,
	"./Home/analytics.svg": 608,
	"./Home/analytics1.svg": 1344,
	"./Home/apolloHospitalsTestimonialIcon.svg": 646,
	"./Home/back-arrow.svg": 613,
	"./Home/banner-dot.svg": 606,
	"./Home/banner-old.svg": 1345,
	"./Home/banner.jpg": 1346,
	"./Home/banner.svg": 599,
	"./Home/ciie_logo.png": 1347,
	"./Home/data-management.mp4": 1348,
	"./Home/datatrack.gif": 1349,
	"./Home/datatrack.svg": 607,
	"./Home/dotted-box.svg": 1350,
	"./Home/dotted-line-mesh-element.svg": 1351,
	"./Home/gray-back-arrow.svg": 614,
	"./Home/gray-next-button.svg": 615,
	"./Home/home-analytics-background.svg": 1352,
	"./Home/home-banner-animation.gif": 1353,
	"./Home/home-graphic-element.svg": 1354,
	"./Home/home-reporting-background.svg": 1355,
	"./Home/img.jpg": 1356,
	"./Home/img2.png": 612,
	"./Home/img2.svg": 1357,
	"./Home/licious.svg": 1358,
	"./Home/mesh-box-1.svg": 1359,
	"./Home/nextButton.svg": 616,
	"./Home/profile.svg": 611,
	"./Home/quote-icon.svg": 617,
	"./Home/reportinHomePageBanner.svg": 609,
	"./Home/reporting.gif": 1360,
	"./Home/reporting.mp4": 1361,
	"./Home/reporting1.mp4": 1362,
	"./Home/security.svg": 605,
	"./Home/tataPowerTestimonialIcon.svg": 645,
	"./Media/ESG_India.svg": 1363,
	"./Media/Rectangle23.jpg": 1364,
	"./Media/Shailesh_sir_image.svg": 1365,
	"./Media/accenture_sust_val_updapt_logo_img.svg": 1366,
	"./Media/algorithmic-governance.webp": 1367,
	"./Media/beyond-carbon-neutrality.jpg": 1368,
	"./Media/blog24.jpg": 1369,
	"./Media/cfo-leadership-summi-in-riyadh.jpg": 1370,
	"./Media/climate-litigation-risk.jpg": 1371,
	"./Media/climate-plans-lost-in-data-matrix.webp": 1372,
	"./Media/coal_work.jpg": 1373,
	"./Media/cohort_announcement.svg": 1374,
	"./Media/cop28-uae.jpg": 1375,
	"./Media/cram_pr.webp": 878,
	"./Media/dnv-updapt-1.png": 879,
	"./Media/dnv-updapt-2.jpg": 880,
	"./Media/dnv_updapt.jpg": 1376,
	"./Media/driving-sustainability-in-the-middle-east.jpg": 1377,
	"./Media/erik-solheim.jpg": 1378,
	"./Media/esg-conclave.jpg": 1379,
	"./Media/esg-img.jpg": 1380,
	"./Media/esg-leadership-summit-2023.jpg": 1381,
	"./Media/esg-summit-2024.jpg": 1382,
	"./Media/esg-summit-updapt-llc-2024.jpg": 1383,
	"./Media/esg.jpg": 1384,
	"./Media/evolving-sustainability-practices-and-global-trends.jpg": 1385,
	"./Media/giftboxes.jpg": 1386,
	"./Media/gitex-impact.jpg": 1387,
	"./Media/harnessing-technology-for-esg.jpg": 1388,
	"./Media/how-esg-is--slowly-making-indian-businesses-future-ready.webp": 1389,
	"./Media/image.png": 1390,
	"./Media/india-responsible-capital-conference-IRCC-2023.jpg": 1391,
	"./Media/interview-with-mr-satish-ramchandani.webp": 1392,
	"./Media/leadership-summit-2024.jpg": 1393,
	"./Media/london-climate-action-week.jpg": 1394,
	"./Media/machine-learning-and-predictive-analytics.png": 1395,
	"./Media/maryam-telmesani-media.jpg": 1396,
	"./Media/mediaTwo.jpg": 1397,
	"./Media/mediaTwoImageOne.jpeg": 881,
	"./Media/nasscom-green-tables.png": 1398,
	"./Media/national-green-infrastructure-conclave-2024.jpg": 1399,
	"./Media/odisha-mining-and-infrastructure-international-expo-2024.jpg": 1400,
	"./Media/plastic-free-wedding.webp": 1401,
	"./Media/plastic_bag.svg": 1402,
	"./Media/race-conferences.jpg": 1403,
	"./Media/rsa_global.jpg": 1404,
	"./Media/satish_ram.svg": 1405,
	"./Media/satishmedia.jpg": 1406,
	"./Media/sebi-stringent-sustainability-reporting.webp": 1407,
	"./Media/solutions-for-a-sustainable-future.jpg": 1408,
	"./Media/spotlight-series-mr-ramveer-tanwar.jpg": 1409,
	"./Media/summit.jpg": 1410,
	"./Media/sustainability-summit-and-awards-2023.jpg": 1411,
	"./Media/the-tech-push-to-esg-data-management.jpg": 1412,
	"./Media/tie-mumbai.jpg": 1413,
	"./Media/updapt's-satish-ramchandani.jpg": 1414,
	"./Media/water-crisis-mirror-now.jpg": 1415,
	"./Media/world-esg-summit.jpg": 1416,
	"./Media/worldmap.svg": 562,
	"./Newsletter/Apr_2026_1.webp": 882,
	"./Newsletter/Apr_2026_2.webp": 883,
	"./Newsletter/Apr_2026_3.webp": 884,
	"./Newsletter/Apr_2026_4.webp": 885,
	"./Newsletter/Apr_2026_5.webp": 886,
	"./Newsletter/Aug_2025_1.webp": 887,
	"./Newsletter/Aug_2025_2.webp": 888,
	"./Newsletter/Aug_2025_3.webp": 889,
	"./Newsletter/Aug_2025_4.webp": 890,
	"./Newsletter/Aug_2025_5.webp": 891,
	"./Newsletter/August_2026_1.webp": 892,
	"./Newsletter/August_2026_2.webp": 893,
	"./Newsletter/August_2026_3.webp": 894,
	"./Newsletter/August_2026_4.webp": 895,
	"./Newsletter/August_2026_5.webp": 896,
	"./Newsletter/Dec_2025_1.webp": 897,
	"./Newsletter/Dec_2025_2.webp": 898,
	"./Newsletter/Dec_2025_3.webp": 899,
	"./Newsletter/Dec_2025_4.webp": 900,
	"./Newsletter/Dec_2025_5.webp": 901,
	"./Newsletter/Feb_2026_1.webp": 902,
	"./Newsletter/Feb_2026_2.webp": 903,
	"./Newsletter/Feb_2026_3.webp": 904,
	"./Newsletter/Feb_2026_4.webp": 905,
	"./Newsletter/Feb_2026_5.webp": 906,
	"./Newsletter/Jan_2026_1.webp": 907,
	"./Newsletter/Jan_2026_2.webp": 908,
	"./Newsletter/Jan_2026_3.webp": 909,
	"./Newsletter/Jan_2026_4.webp": 910,
	"./Newsletter/Jan_2026_5.webp": 911,
	"./Newsletter/July_2026_1.webp": 912,
	"./Newsletter/July_2026_2.webp": 913,
	"./Newsletter/July_2026_3.webp": 914,
	"./Newsletter/July_2026_4.webp": 915,
	"./Newsletter/July_2026_5.webp": 916,
	"./Newsletter/June 2022.svg": 1417,
	"./Newsletter/June_2026_1.webp": 917,
	"./Newsletter/June_2026_2.webp": 918,
	"./Newsletter/June_2026_3.webp": 919,
	"./Newsletter/June_2026_4.webp": 920,
	"./Newsletter/June_2026_5.webp": 921,
	"./Newsletter/Mar_2026_1.webp": 922,
	"./Newsletter/Mar_2026_2.webp": 923,
	"./Newsletter/Mar_2026_3.webp": 924,
	"./Newsletter/Mar_2026_4.webp": 925,
	"./Newsletter/Mar_2026_5.webp": 926,
	"./Newsletter/May_2026_1.webp": 927,
	"./Newsletter/May_2026_2.webp": 928,
	"./Newsletter/May_2026_3.webp": 929,
	"./Newsletter/May_2026_4.webp": 930,
	"./Newsletter/May_2026_5.webp": 931,
	"./Newsletter/Newsletter-sample-image.svg": 1418,
	"./Newsletter/Nov_2025_1.webp": 932,
	"./Newsletter/Nov_2025_2.webp": 933,
	"./Newsletter/Nov_2025_3.webp": 934,
	"./Newsletter/Nov_2025_4.webp": 935,
	"./Newsletter/Nov_2025_5.webp": 936,
	"./Newsletter/November_2026_1.webp": 937,
	"./Newsletter/November_2026_2.webp": 938,
	"./Newsletter/November_2026_3.webp": 939,
	"./Newsletter/November_2026_4.webp": 940,
	"./Newsletter/November_2026_5.webp": 941,
	"./Newsletter/Oct_2025_1.webp": 942,
	"./Newsletter/Oct_2025_2.webp": 943,
	"./Newsletter/Oct_2025_3.webp": 944,
	"./Newsletter/Oct_2025_4.webp": 945,
	"./Newsletter/Oct_2025_5.webp": 946,
	"./Newsletter/October_2026_1.webp": 947,
	"./Newsletter/October_2026_2.webp": 948,
	"./Newsletter/October_2026_3.webp": 949,
	"./Newsletter/October_2026_4.webp": 950,
	"./Newsletter/October_2026_5.webp": 951,
	"./Newsletter/Sep_2025_1.webp": 952,
	"./Newsletter/Sep_2025_2.webp": 953,
	"./Newsletter/Sep_2025_3.webp": 954,
	"./Newsletter/Sep_2025_4.webp": 955,
	"./Newsletter/Sep_2025_5.webp": 956,
	"./Newsletter/September_2026_1.webp": 957,
	"./Newsletter/September_2026_2.webp": 958,
	"./Newsletter/September_2026_3.webp": 959,
	"./Newsletter/September_2026_4.webp": 960,
	"./Newsletter/September_2026_5.webp": 961,
	"./Newsletter/UAE.jpg": 1419,
	"./Newsletter/apr 2021.svg": 1420,
	"./Newsletter/apr2023-1.jpg": 1421,
	"./Newsletter/apr2024-1.jpg": 1422,
	"./Newsletter/april-2022.svg": 1423,
	"./Newsletter/aug-2022.svg": 1424,
	"./Newsletter/aug2021.svg": 1425,
	"./Newsletter/august2023-1.jpg": 1426,
	"./Newsletter/august2024-1.jpg": 1427,
	"./Newsletter/dec 2020.svg": 1428,
	"./Newsletter/dec 2021.svg": 1429,
	"./Newsletter/dec2023-1.jpg": 1430,
	"./Newsletter/feb 2021.svg": 1431,
	"./Newsletter/feb-2022.svg": 1432,
	"./Newsletter/feb2023-1.jpg": 1433,
	"./Newsletter/feb2024-1.jpg": 1434,
	"./Newsletter/handImg.jpg": 1435,
	"./Newsletter/img_1.jpg": 1436,
	"./Newsletter/jan 2021.svg": 1437,
	"./Newsletter/jan 2022.svg": 1438,
	"./Newsletter/jan1.jpg": 1439,
	"./Newsletter/jan2024-1.jpg": 1440,
	"./Newsletter/july 2021.svg": 1441,
	"./Newsletter/july-2022.svg": 1442,
	"./Newsletter/july2023-1.jpg": 1443,
	"./Newsletter/july2024-1.jpg": 1444,
	"./Newsletter/june 2021.svg": 1445,
	"./Newsletter/june-2022.svg": 1446,
	"./Newsletter/june2023-1.jpg": 1447,
	"./Newsletter/june2024-1.svg": 1448,
	"./Newsletter/last.jpg": 1449,
	"./Newsletter/mar 2021.svg": 1450,
	"./Newsletter/mar-2022.svg": 1451,
	"./Newsletter/mar2024-1.jpg": 1452,
	"./Newsletter/march2023-1.jpg": 1453,
	"./Newsletter/may 2021.svg": 1454,
	"./Newsletter/may 2022.svg": 1455,
	"./Newsletter/may2023-1.jpg": 1456,
	"./Newsletter/may2024-1.jpg": 1457,
	"./Newsletter/news.jpg": 1458,
	"./Newsletter/news2.jpg": 1459,
	"./Newsletter/newsImage.jpg": 1460,
	"./Newsletter/newsletter-2023.png": 1461,
	"./Newsletter/newsletter1.jpg": 1462,
	"./Newsletter/newsletter2.jpg": 1463,
	"./Newsletter/newsletter3.jpg": 1464,
	"./Newsletter/newsletterPic.jpg": 1465,
	"./Newsletter/nov 2020.svg": 1466,
	"./Newsletter/nov 2021.svg": 1467,
	"./Newsletter/nov-2020.svg": 1468,
	"./Newsletter/nov2023-1.jpg": 1469,
	"./Newsletter/oct 2021.svg": 1470,
	"./Newsletter/oct2023-1.jpeg": 1471,
	"./Newsletter/one.jpg": 1472,
	"./Newsletter/oneWorld.jpg": 1473,
	"./Newsletter/plant.png": 1474,
	"./Newsletter/sep-2022.svg": 1475,
	"./Newsletter/sep2023-1.jpg": 962,
	"./Newsletter/sep2023-2.jpg": 963,
	"./Newsletter/sep2023-3.jpg": 964,
	"./Newsletter/sep2023-4.jpg": 965,
	"./Newsletter/sep2023-5.jpg": 966,
	"./Newsletter/sept 2021.svg": 1476,
	"./Newsletter/september2024-1.jpg": 1477,
	"./Newsletter/view.svg": 699,
	"./Newsletter/view1.svg": 2,
	"./Newsletter5/Newsletter-sample-image.svg": 1478,
	"./Newsletter5/apr 2021.svg": 1479,
	"./Newsletter5/april-2022.svg": 1480,
	"./Newsletter5/april.svg": 1481,
	"./Newsletter5/aug2021.svg": 1482,
	"./Newsletter5/dec 2020.svg": 1483,
	"./Newsletter5/dec 2021.svg": 1484,
	"./Newsletter5/feb 2021.svg": 1485,
	"./Newsletter5/feb2022.svg": 1486,
	"./Newsletter5/february-2022.svg": 1487,
	"./Newsletter5/jan 2021.svg": 1488,
	"./Newsletter5/jan 2022.svg": 1489,
	"./Newsletter5/july 2021.svg": 1490,
	"./Newsletter5/june 2021.svg": 1491,
	"./Newsletter5/mar 2021.svg": 1492,
	"./Newsletter5/mar-2022.svg": 1493,
	"./Newsletter5/may 2021.svg": 1494,
	"./Newsletter5/may 2022.svg": 1495,
	"./Newsletter5/nov 2020.svg": 1496,
	"./Newsletter5/nov 2021.svg": 1497,
	"./Newsletter5/oct 2021.svg": 1498,
	"./Newsletter5/sept 2021.svg": 1499,
	"./Solution/analysis.svg": 1500,
	"./Solution/analytics-images/1.svg": 572,
	"./Solution/analytics-images/2.svg": 573,
	"./Solution/analytics-images/3.svg": 574,
	"./Solution/analytics-images/4.svg": 575,
	"./Solution/analytics-images/image1.png": 1501,
	"./Solution/csrd/bg_1.svg": 967,
	"./Solution/csrd/csrd_dashboard.svg": 968,
	"./Solution/csrd/csrd_dc.svg": 969,
	"./Solution/csrd/data_collection.svg": 1502,
	"./Solution/csrd/dma.svg": 1503,
	"./Solution/csrd/dma_1.svg": 970,
	"./Solution/csrd/reporting.svg": 971,
	"./Solution/data-track.svg": 1504,
	"./Solution/datatrack-images/1.svg": 567,
	"./Solution/datatrack-images/2.svg": 568,
	"./Solution/datatrack-images/3.svg": 569,
	"./Solution/datatrack-images/4.svg": 570,
	"./Solution/datatrack-images/5.svg": 571,
	"./Solution/erm-images/1.svg": 583,
	"./Solution/erm-images/2.svg": 584,
	"./Solution/erm-images/3.svg": 585,
	"./Solution/erm-images/4.svg": 586,
	"./Solution/erm-images/5.svg": 587,
	"./Solution/grant-management.svg": 1505,
	"./Solution/graphic-element-1.svg": 1506,
	"./Solution/graphic-element-2.svg": 1507,
	"./Solution/nz-images/1.svg": 581,
	"./Solution/nz-images/2.svg": 582,
	"./Solution/nz-images/3.svg": 580,
	"./Solution/pa-images/1.svg": 593,
	"./Solution/pa-images/2.svg": 594,
	"./Solution/pa-images/3.svg": 595,
	"./Solution/pa-images/4.svg": 596,
	"./Solution/pa-images/5.svg": 597,
	"./Solution/reporting-images/1.svg": 576,
	"./Solution/reporting-images/2.svg": 577,
	"./Solution/reporting-images/3.svg": 578,
	"./Solution/reporting-images/4.svg": 579,
	"./Solution/reporting.svg": 1508,
	"./Solution/scm-images/1.svg": 588,
	"./Solution/scm-images/2.svg": 589,
	"./Solution/scm-images/3.svg": 590,
	"./Solution/scm-images/4.svg": 591,
	"./Solution/scm-images/5.svg": 592,
	"./aboutuspage/AnkithaB.svg": 1509,
	"./aboutuspage/Chinthan.svg": 631,
	"./aboutuspage/DivyashreeC.svg": 632,
	"./aboutuspage/EricSolheim.svg": 627,
	"./aboutuspage/MithunSuvarna.svg": 622,
	"./aboutuspage/NitheshPadival.svg": 633,
	"./aboutuspage/NitheshPadival1.svg": 1510,
	"./aboutuspage/Sangath.svg": 624,
	"./aboutuspage/Saptham.svg": 634,
	"./aboutuspage/Saptham1.svg": 1511,
	"./aboutuspage/SathwikRai.svg": 636,
	"./aboutuspage/SathwikRai1.svg": 1512,
	"./aboutuspage/SatishRamchandani.svg": 623,
	"./aboutuspage/Shailesh.svg": 626,
	"./aboutuspage/SupreethRao.svg": 625,
	"./aboutuspage/akash.svg": 635,
	"./aboutuspage/maryamTelmesani.svg": 629,
	"./aboutuspage/sanmiO.svg": 630,
	"./aboutuspage/shailesh.jpeg": 1513,
	"./aboutuspage/vineetAgarwal.svg": 628,
	"./brsrLandingPage/Demo1.svg": 972,
	"./brsrLandingPage/Group 11094 (1).svg": 1514,
	"./brsrLandingPage/brsrBannerImage1.svg": 973,
	"./brsrLandingPage/brsrBannerImage2.svg": 974,
	"./brsrLandingPage/brsrBannerImage3.svg": 975,
	"./brsrLandingPage/brsrMainBanner.svg": 1515,
	"./brsrLandingPage/corePrincipleIcons/1.svg": 976,
	"./brsrLandingPage/corePrincipleIcons/2.svg": 977,
	"./brsrLandingPage/corePrincipleIcons/3.svg": 978,
	"./brsrLandingPage/corePrincipleIcons/4.svg": 979,
	"./brsrLandingPage/corePrincipleIcons/5.svg": 980,
	"./brsrLandingPage/corePrincipleIcons/6.svg": 981,
	"./brsrLandingPage/corePrincipleIcons/7.svg": 982,
	"./brsrLandingPage/corePrincipleIcons/8.svg": 983,
	"./brsrLandingPage/corePrincipleIcons/9.svg": 984,
	"./brsrLandingPage/corePrinciples.svg": 1516,
	"./brsrLandingPage/demo2.svg": 985,
	"./brsrLandingPage/esgTools/1.svg": 1517,
	"./brsrLandingPage/esgTools/2.svg": 1518,
	"./brsrLandingPage/esgTools/3.svg": 1519,
	"./brsrLandingPage/esgTools/4.svg": 1520,
	"./brsrLandingPage/esgTools/5.svg": 1521,
	"./brsrLandingPage/freeTrial.svg": 986,
	"./brsrLandingPage/mainBannerCurvedSection.svg": 987,
	"./brsrLandingPage/otherProducts/1.svg": 303,
	"./brsrLandingPage/otherProducts/2.svg": 304,
	"./brsrLandingPage/otherProducts/3.svg": 305,
	"./brsrLandingPage/otherProducts/4.svg": 306,
	"./brsrLandingPage/otherProductsBg.svg": 1522,
	"./brsrLandingPage/performanceManagementBg.svg": 988,
	"./brsrLandingPage/secondDemoBg.svg": 989,
	"./brsrLandingPage/simplifyingBrsrReport.svg": 1523,
	"./brsrLandingPage/simplifyingBrsrReporting/1.svg": 990,
	"./brsrLandingPage/simplifyingBrsrReporting/2.svg": 991,
	"./brsrLandingPage/simplifyingBrsrReporting/3.svg": 992,
	"./brsrLandingPage/simplifyingBrsrReporting/4.svg": 993,
	"./brsrLandingPage/simplifyingBrsrReporting/5.svg": 994,
	"./brsrLandingPage/simplifyingBrsrReporting/6.svg": 995,
	"./brsrLandingPage/updaptLogo.svg": 996,
	"./brsrLandingPage/updaptULogo.svg": 1524,
	"./contactuspage/address.svg": 1525,
	"./contactuspage/email.svg": 1526,
	"./contactuspage/graphic-element-bottom.svg": 563,
	"./contactuspage/phone.svg": 1527,
	"./icons/Capacity-management.svg": 618,
	"./icons/Data-backup.svg": 619,
	"./icons/Email-icon.svg": 1528,
	"./icons/Encryption.svg": 620,
	"./icons/Indian-Flag.svg": 1529,
	"./icons/Location-icon.svg": 1530,
	"./icons/Nigeria_flag.svg": 1531,
	"./icons/Phone-icon.svg": 1532,
	"./icons/Plant.png": 1533,
	"./icons/Tanzania_flag.svg": 1534,
	"./icons/Vitual-Private-Cloud.svg": 621,
	"./icons/about_us_w_circle.svg": 697,
	"./icons/accordion arrow.svg": 712,
	"./icons/advanced-tree-sphere.svg": 1535,
	"./icons/advisory.svg": 1536,
	"./icons/affliate.svg": 694,
	"./icons/analytics.svg": 1537,
	"./icons/apple-podcast.svg": 1538,
	"./icons/arrow-angle-up.svg": 689,
	"./icons/backward.svg": 703,
	"./icons/bespoke-tree-sphere.svg": 1539,
	"./icons/careersNavIcon.svg": 711,
	"./icons/caseStudyIcon.svg": 713,
	"./icons/checkmark.svg": 1540,
	"./icons/client_nav_icon.svg": 674,
	"./icons/closeIcon.svg": 708,
	"./icons/cloud.svg": 1541,
	"./icons/consulting.svg": 695,
	"./icons/csrd_nav.svg": 715,
	"./icons/customization.svg": 1542,
	"./icons/datatrack.svg": 1543,
	"./icons/deliver.svg": 1544,
	"./icons/download-icon.svg": 706,
	"./icons/email.svg": 244,
	"./icons/essential-sphere.svg": 1545,
	"./icons/experience.svg": 1546,
	"./icons/facebook-podcast.svg": 307,
	"./icons/facebook.svg": 1547,
	"./icons/forward.svg": 702,
	"./icons/gdpr-icon.svg": 1548,
	"./icons/global-goals.svg": 1549,
	"./icons/google-podcast.svg": 308,
	"./icons/grant.svg": 1550,
	"./icons/home-capacity-management.svg": 1551,
	"./icons/home-data-backup.svg": 1552,
	"./icons/home-encryption.svg": 1553,
	"./icons/home-vpc.svg": 1554,
	"./icons/icons": 246,
	"./icons/icons.js": 246,
	"./icons/india_flag.svg": 150,
	"./icons/instagram.svg": 1555,
	"./icons/linkedin-grey.svg": 1556,
	"./icons/linkedin-podcast.svg": 309,
	"./icons/linkedin.svg": 1557,
	"./icons/linkedinlogo.svg": 1558,
	"./icons/linkedlogo.png": 1559,
	"./icons/location.svg": 710,
	"./icons/logo-analytics.svg": 1560,
	"./icons/logo-data-management.svg": 1561,
	"./icons/logo-grant-management.svg": 1562,
	"./icons/logo-reporting.svg": 1563,
	"./icons/maIcon.svg": 714,
	"./icons/menu-icon.svg": 1564,
	"./icons/mute-volume.svg": 705,
	"./icons/open-in-window-hover.svg": 1565,
	"./icons/open-in-window.svg": 1566,
	"./icons/partners_w_circle.svg": 698,
	"./icons/pause.svg": 701,
	"./icons/phone.svg": 245,
	"./icons/play.svg": 700,
	"./icons/podcast-nav-icon.svg": 707,
	"./icons/pricing.svg": 1567,
	"./icons/rahul.svg": 686,
	"./icons/reseller.svg": 693,
	"./icons/right-arrow.svg": 687,
	"./icons/rightArrowIconWhite.svg": 688,
	"./icons/searchIcon.svg": 709,
	"./icons/security.svg": 1568,
	"./icons/spotify.svg": 310,
	"./icons/standard-plant-sphere.svg": 1569,
	"./icons/tanzania.svg": 1570,
	"./icons/technology.svg": 696,
	"./icons/tree-sphere.svg": 1571,
	"./icons/twitter-podcast.svg": 311,
	"./icons/twitter.svg": 1572,
	"./icons/uae_flag.svg": 997,
	"./icons/uk_flag.svg": 998,
	"./icons/usa_flag.svg": 999,
	"./icons/volume.svg": 704,
	"./icons/white-check.svg": 1573,
	"./images/10_sahyadrihospitals.svg": 210,
	"./images/11_omh_omega.svg": 211,
	"./images/12_calibre.svg": 212,
	"./images/13_chemopharm.svg": 213,
	"./images/14_cpc.svg": 214,
	"./images/15_fandbasia.svg": 215,
	"./images/16_harrys.svg": 216,
	"./images/17_burgerking.svg": 217,
	"./images/1_cipla.svg": 205,
	"./images/2_tatapower.svg": 206,
	"./images/3_licious.svg": 207,
	"./images/4_apollo.svg": 1000,
	"./images/5_cochinshipyard.svg": 208,
	"./images/6_pricol.svg": 1001,
	"./images/7_everstone.svg": 209,
	"./images/8_api.svg": 1002,
	"./images/Ankitha-B.svg": 1003,
	"./images/Background.svg": 1004,
	"./images/BelindaSabatierMondjo.svg": 243,
	"./images/Blog23.jpg": 1005,
	"./images/California.jpg": 312,
	"./images/Chinthan.svg": 1006,
	"./images/Divyashree-C.svg": 1007,
	"./images/EU.jpg": 313,
	"./images/G7Countries.jpg": 314,
	"./images/Global.jpg": 315,
	"./images/Mithun-Suvarna.svg": 1008,
	"./images/Nithesh-Padival.svg": 1009,
	"./images/Oct-Blog-image.jpg": 1010,
	"./images/Plant.png": 1011,
	"./images/Podcast-banner.jpg": 316,
	"./images/Podcast-banner.svg": 1012,
	"./images/RectangleBlue.svg": 1013,
	"./images/Sangath.svg": 1014,
	"./images/Saptham.svg": 1015,
	"./images/Sathwik-Rai.svg": 1016,
	"./images/Satish-Ramchandani.svg": 1017,
	"./images/Supreeth-Rao.svg": 1018,
	"./images/Switzerland.jpg": 317,
	"./images/Thailand.jpeg": 1019,
	"./images/UAE.jpg": 318,
	"./images/aarksee.jpg": 195,
	"./images/accenture.png": 1020,
	"./images/accenture.svg": 172,
	"./images/ais.png": 173,
	"./images/analytics.mp4": 1021,
	"./images/apr2023-1.jpg": 319,
	"./images/apr2023-2.jpg": 320,
	"./images/apr2023-3.jpg": 321,
	"./images/apr2023-4.jpg": 322,
	"./images/apr2023-5.jpg": 323,
	"./images/apr2024-1.jpg": 324,
	"./images/apr2024-2.jpg": 325,
	"./images/apr2024-3.jpg": 326,
	"./images/apr2024-4.jpg": 327,
	"./images/apr2025_austrelia.webp": 1022,
	"./images/apr2025_cdfr.webp": 328,
	"./images/apr2025_crf.webp": 329,
	"./images/apr2025_decarbon.webp": 330,
	"./images/apr2025_ifrs.webp": 331,
	"./images/apr2025_steel.webp": 332,
	"./images/august2023-1.jpg": 151,
	"./images/august2023-2.jpg": 333,
	"./images/august2023-3.jpg": 334,
	"./images/august2023-4.jpg": 335,
	"./images/august2023-5.jpg": 336,
	"./images/august2024-1.jpg": 337,
	"./images/august2024-2.jpg": 338,
	"./images/august2024-3.jpg": 339,
	"./images/august2024-4.jpg": 340,
	"./images/august2024-5.jpg": 341,
	"./images/aus_feb_2025.webp": 342,
	"./images/bg-landingpage.svg": 1023,
	"./images/blog-12.svg": 1024,
	"./images/blue-bg-img.svg": 1025,
	"./images/blueOceanSystems.png": 174,
	"./images/blueSky.png": 175,
	"./images/canada-vpj.jpg": 1026,
	"./images/canada.jpg": 343,
	"./images/careerCollage.webp": 171,
	"./images/careersBanner.svg": 170,
	"./images/cementIndustry.jpg": 1027,
	"./images/ciplaImg.svg": 1028,
	"./images/client_logos/aarti.svg": 137,
	"./images/client_logos/amararaja.svg": 138,
	"./images/client_logos/amiOrganicsLogo.svg": 117,
	"./images/client_logos/apollohospitals.svg": 344,
	"./images/client_logos/ashokLeyland.svg": 125,
	"./images/client_logos/aveo.svg": 345,
	"./images/client_logos/ayana.svg": 67,
	"./images/client_logos/birlaGroupLogo.svg": 120,
	"./images/client_logos/bitmore.svg": 346,
	"./images/client_logos/bluePlanet.svg": 129,
	"./images/client_logos/burgerking.svg": 347,
	"./images/client_logos/calibre.svg": 348,
	"./images/client_logos/ceat.svg": 102,
	"./images/client_logos/cgpower.svg": 68,
	"./images/client_logos/chemopharm.svg": 69,
	"./images/client_logos/cipla.svg": 349,
	"./images/client_logos/cochinshipyard.svg": 350,
	"./images/client_logos/cohizon.svg": 351,
	"./images/client_logos/cookieman.svg": 352,
	"./images/client_logos/cpc.svg": 70,
	"./images/client_logos/cumiLogo.svg": 121,
	"./images/client_logos/data_esg.svg": 66,
	"./images/client_logos/deepak_nitrite_logo.svg": 108,
	"./images/client_logos/dominos.svg": 353,
	"./images/client_logos/dsg.svg": 354,
	"./images/client_logos/emrill.svg": 71,
	"./images/client_logos/epsilonLogo.svg": 118,
	"./images/client_logos/escortsKubota.svg": 130,
	"./images/client_logos/eveready.svg": 139,
	"./images/client_logos/everenviro.svg": 73,
	"./images/client_logos/everest_industrial_logo.svg": 109,
	"./images/client_logos/everise.svg": 74,
	"./images/client_logos/everlife-1.svg": 76,
	"./images/client_logos/everlife.svg": 75,
	"./images/client_logos/eversource.svg": 77,
	"./images/client_logos/everstone.svg": 355,
	"./images/client_logos/fnb_asia.svg": 356,
	"./images/client_logos/freshways.svg": 357,
	"./images/client_logos/ghcl.svg": 101,
	"./images/client_logos/gmr.svg": 140,
	"./images/client_logos/gokaldasExports.svg": 126,
	"./images/client_logos/grInfra.svg": 127,
	"./images/client_logos/greencell.svg": 78,
	"./images/client_logos/harrys.svg": 358,
	"./images/client_logos/harrys_logo.svg": 110,
	"./images/client_logos/hcl.svg": 359,
	"./images/client_logos/hinduja.svg": 145,
	"./images/client_logos/igarashiMotors.svg": 128,
	"./images/client_logos/iifl_finance.svg": 79,
	"./images/client_logos/indoramaCorporation.svg": 131,
	"./images/client_logos/indospace.svg": 80,
	"./images/client_logos/indostar.svg": 81,
	"./images/client_logos/infostretch.svg": 82,
	"./images/client_logos/infosys.svg": 360,
	"./images/client_logos/ips.svg": 146,
	"./images/client_logos/jKCements.svg": 123,
	"./images/client_logos/jsla.svg": 141,
	"./images/client_logos/kathari.svg": 83,
	"./images/client_logos/kuantumPapers.svg": 124,
	"./images/client_logos/lTFinance.svg": 132,
	"./images/client_logos/lakshmimachineworks.svg": 84,
	"./images/client_logos/licious.svg": 361,
	"./images/client_logos/lithium.svg": 85,
	"./images/client_logos/lloyd_metals.svg": 111,
	"./images/client_logos/lodha.svg": 362,
	"./images/client_logos/lupin.svg": 86,
	"./images/client_logos/mastek.svg": 112,
	"./images/client_logos/multiples.svg": 104,
	"./images/client_logos/narayanaHealthLogo.svg": 122,
	"./images/client_logos/omega_healthcare.svg": 363,
	"./images/client_logos/pgp_glass.svg": 87,
	"./images/client_logos/polycycle.png": 364,
	"./images/client_logos/polyplastics.svg": 133,
	"./images/client_logos/pricol.svg": 365,
	"./images/client_logos/prism-johnson.svg": 134,
	"./images/client_logos/protean_logo.svg": 366,
	"./images/client_logos/radiaant_logo.svg": 113,
	"./images/client_logos/radiance.svg": 88,
	"./images/client_logos/rakbank.svg": 147,
	"./images/client_logos/ramco.svg": 89,
	"./images/client_logos/re_sustainability.svg": 90,
	"./images/client_logos/refex.svg": 106,
	"./images/client_logos/republicBank.svg": 105,
	"./images/client_logos/rhi_magnesita.svg": 91,
	"./images/client_logos/sahyadri.svg": 92,
	"./images/client_logos/sbi_card.svg": 72,
	"./images/client_logos/servion.svg": 93,
	"./images/client_logos/shapoorji_pallonji_logo.svg": 114,
	"./images/client_logos/shoprite.svg": 149,
	"./images/client_logos/sjs.svg": 94,
	"./images/client_logos/skf.svg": 367,
	"./images/client_logos/softgel.svg": 95,
	"./images/client_logos/sohanlal.svg": 96,
	"./images/client_logos/sulochana.svg": 103,
	"./images/client_logos/sunpharma.svg": 97,
	"./images/client_logos/supremeLogo.svg": 115,
	"./images/client_logos/sutherlandLogo.svg": 119,
	"./images/client_logos/suzlonLogo.svg": 116,
	"./images/client_logos/tata-consumer-products.svg": 135,
	"./images/client_logos/tata-projects.svg": 144,
	"./images/client_logos/tatapower.svg": 98,
	"./images/client_logos/tech-mahindra-ctco.svg": 148,
	"./images/client_logos/tolaram.svg": 99,
	"./images/client_logos/translumina.svg": 100,
	"./images/client_logos/trident.svg": 136,
	"./images/client_logos/uflex.svg": 142,
	"./images/client_logos/wns.svg": 143,
	"./images/client_logos/zahid_group.svg": 368,
	"./images/client_logos/zee.svg": 107,
	"./images/client_logos/zomato.svg": 369,
	"./images/clients/11_dsg.svg": 232,
	"./images/clients/12_burger.svg": 233,
	"./images/clients/13_cohizon.svg": 234,
	"./images/clients/14_everstone.svg": 235,
	"./images/clients/15_fnbasia.svg": 236,
	"./images/clients/16_skf.svg": 237,
	"./images/clients/17_calibre.svg": 238,
	"./images/clients/18_esgds.svg": 239,
	"./images/clients/19_bitmore.svg": 1029,
	"./images/clients/1_cipla.svg": 225,
	"./images/clients/20_lodha.svg": 240,
	"./images/clients/2_tata.svg": 226,
	"./images/clients/3_apollo.svg": 227,
	"./images/clients/4_pricol.svg": 1030,
	"./images/clients/5_cochin.svg": 228,
	"./images/clients/6_licious.svg": 229,
	"./images/clients/8_omega.svg": 230,
	"./images/clients/9_cookieman.svg": 231,
	"./images/dec2023-1.jpg": 370,
	"./images/dec2023-2.jpg": 371,
	"./images/dec2023-3.jpg": 372,
	"./images/dec2023-4.jpg": 373,
	"./images/dec2023-5.jpg": 374,
	"./images/dec2024-1.webp": 375,
	"./images/dec2024-2.webp": 376,
	"./images/dec2024-3.webp": 377,
	"./images/dec2024-4.webp": 378,
	"./images/dec2024-5.jpeg": 379,
	"./images/digeto.png": 196,
	"./images/dmWorld.png": 176,
	"./images/dm_world.svg": 219,
	"./images/dnv.png": 1031,
	"./images/dnv.svg": 177,
	"./images/earthood.png": 178,
	"./images/eba_feb_2025.webp": 380,
	"./images/eba_thumbnail.jpeg": 1032,
	"./images/ecolibrium.svg": 222,
	"./images/empoweredAnalytics.png": 179,
	"./images/eu_feb_2025.webp": 381,
	"./images/europe.jpg": 382,
	"./images/facilityManagement.jpg": 1033,
	"./images/feb2023-1.jpg": 383,
	"./images/feb2023-2.jpg": 384,
	"./images/feb2023-3.jpg": 385,
	"./images/feb2023-4.jpg": 386,
	"./images/feb2023-5.jpg": 387,
	"./images/feb2024-1.jpg": 388,
	"./images/feb2024-2.jpg": 389,
	"./images/feb2024-3.jpg": 390,
	"./images/feb2024-4.jpg": 391,
	"./images/feb2024-5.jpg": 392,
	"./images/fmcgCase.jpg": 1034,
	"./images/fuel_feb_2025.webp": 393,
	"./images/grantThornton.jpg": 197,
	"./images/green-bg-img.svg": 1035,
	"./images/greenBeeEnergy.png": 180,
	"./images/greenConsults.jpg": 202,
	"./images/greenbee.svg": 220,
	"./images/handImg.jpg": 1036,
	"./images/hcl.svg": 181,
	"./images/header-green-bg.svg": 1037,
	"./images/healthCare.jpg": 1038,
	"./images/honeycomb-mobile.svg": 1039,
	"./images/honeycomb.svg": 1040,
	"./images/ifcom.jpg": 183,
	"./images/ifrs_thumbnail.jpeg": 1041,
	"./images/image4.png": 394,
	"./images/image_4.jpg": 395,
	"./images/img_1.jpg": 396,
	"./images/img_2.jpg": 397,
	"./images/img_3.jpg": 398,
	"./images/img_4.jpg": 399,
	"./images/img_5.jpg": 1042,
	"./images/imss.png": 182,
	"./images/india_map.svg": 1043,
	"./images/itqan.png": 184,
	"./images/jan1.jpg": 400,
	"./images/jan2.jpg": 401,
	"./images/jan2024-1.jpg": 402,
	"./images/jan2024-2.jpg": 403,
	"./images/jan2024-3.jpg": 404,
	"./images/jan2024-4.jpg": 405,
	"./images/jan2024-5.jpg": 406,
	"./images/jan3.jpg": 407,
	"./images/jan4.jpg": 408,
	"./images/jan5.jpg": 409,
	"./images/july2023-1.jpg": 410,
	"./images/july2023-2.jpg": 411,
	"./images/july2023-3.jpg": 412,
	"./images/july2023-4.jpg": 413,
	"./images/july2023-5.jpg": 414,
	"./images/july2024-1.jpg": 415,
	"./images/july2024-2.jpg": 416,
	"./images/july2024-3.jpg": 417,
	"./images/july2024-4.jpg": 418,
	"./images/july2024-5.jpg": 419,
	"./images/july_2025_1.jpg": 1044,
	"./images/july_2025_1.webp": 420,
	"./images/july_2025_2.webp": 421,
	"./images/july_2025_3.webp": 422,
	"./images/july_2025_4.webp": 423,
	"./images/july_2025_5.webp": 424,
	"./images/june2023-1.jpg": 425,
	"./images/june2023-2.jpg": 426,
	"./images/june2023-3.jpg": 427,
	"./images/june2023-4.jpg": 428,
	"./images/june2023-5.webp": 429,
	"./images/june2024-1.webp": 430,
	"./images/june2024-2.webp": 431,
	"./images/june2024-3.webp": 432,
	"./images/june2024-4.webp": 433,
	"./images/june2024-5.webp": 434,
	"./images/june_2025_1.jpeg": 1045,
	"./images/june_2025_1.webp": 435,
	"./images/june_2025_2.webp": 436,
	"./images/june_2025_3.webp": 437,
	"./images/june_2025_4.webp": 438,
	"./images/june_2025_5.webp": 439,
	"./images/last.jpg": 440,
	"./images/left-arrow-with-lines.svg": 1046,
	"./images/lhs_circle.svg": 223,
	"./images/liciousImg.svg": 1047,
	"./images/lithe.jpeg": 199,
	"./images/logo-green.png": 1048,
	"./images/logo-green.svg": 1049,
	"./images/logo-small-green.png": 1050,
	"./images/logo-small-green.svg": 1051,
	"./images/logo-white.svg": 1052,
	"./images/lybra.svg": 193,
	"./images/ma-1.svg": 441,
	"./images/ma-2.svg": 442,
	"./images/ma-3.svg": 443,
	"./images/ma-4-1.svg": 444,
	"./images/ma-4.svg": 445,
	"./images/ma-5.svg": 446,
	"./images/ma-6.svg": 447,
	"./images/mar2024-1.jpg": 448,
	"./images/mar2024-2.jpg": 449,
	"./images/mar2024-3.jpg": 450,
	"./images/mar2024-4.jpg": 451,
	"./images/mar2024-5.jpg": 452,
	"./images/march2023-1.jpg": 1053,
	"./images/march2023-2.jpg": 453,
	"./images/march2023-3.jpg": 454,
	"./images/march2023-4.jpg": 455,
	"./images/march2023-5.jpg": 456,
	"./images/march2025-1.webp": 457,
	"./images/march2025-2.webp": 458,
	"./images/march2025-3.webp": 459,
	"./images/march2025-4.webp": 460,
	"./images/march2025-5.webp": 461,
	"./images/march2025-thumbnail.jpeg": 1054,
	"./images/may2023-1.jpg": 462,
	"./images/may2023-2.jpg": 463,
	"./images/may2023-3.jpg": 464,
	"./images/may2023-4.jpg": 465,
	"./images/may2023-5.jpg": 466,
	"./images/may2024-1.jpg": 467,
	"./images/may2024-2.jpg": 468,
	"./images/may2024-3.jpg": 469,
	"./images/may2024-4.jpg": 470,
	"./images/may2024-5.jpg": 471,
	"./images/may_2025_1.jpeg": 1055,
	"./images/may_2025_1.webp": 472,
	"./images/may_2025_2.webp": 473,
	"./images/may_2025_3.webp": 474,
	"./images/may_2025_4.webp": 475,
	"./images/may_2025_5.webp": 476,
	"./images/mobile-green-bg.svg": 1056,
	"./images/moduleCloseButton.svg": 477,
	"./images/monitor.svg": 1057,
	"./images/nethronix.svg": 194,
	"./images/newLogo.png": 1058,
	"./images/newLogo.svg": 1059,
	"./images/newLogoold.svg": 1060,
	"./images/news.jpg": 1061,
	"./images/news3.jpg": 1062,
	"./images/news4.jpg": 478,
	"./images/news5.jpg": 479,
	"./images/news6.jpg": 480,
	"./images/news7.jpg": 481,
	"./images/newsImage.jpg": 1063,
	"./images/newsletter-2023.png": 482,
	"./images/nigeria.svg": 1064,
	"./images/nov2023-1.jpg": 483,
	"./images/nov2023-2.jpg": 484,
	"./images/nov2023-3.jpg": 485,
	"./images/nov2023-4.jpg": 486,
	"./images/nov2023-5.jpg": 487,
	"./images/nov2024-1.webp": 488,
	"./images/nov2024-2.webp": 489,
	"./images/nov2024-3.jpg": 490,
	"./images/nov2024-4.webp": 491,
	"./images/nov2024-5.webp": 492,
	"./images/oct2023-1.jpeg": 493,
	"./images/oct2023-2.jpeg": 494,
	"./images/oct2023-3.jpeg": 495,
	"./images/oct2023-4.jpeg": 496,
	"./images/oct2023-5.jpeg": 497,
	"./images/october2024-1.webp": 498,
	"./images/october2024-2.webp": 499,
	"./images/october2024-3.webp": 500,
	"./images/october2024-4.webp": 501,
	"./images/october2024-5.webp": 502,
	"./images/oizom.svg": 221,
	"./images/pallavi-singh.jpg": 166,
	"./images/partnership.svg": 218,
	"./images/pccs.png": 185,
	"./images/pgso.png": 186,
	"./images/pharmaCase.jpg": 1065,
	"./images/platform-image.svg": 1066,
	"./images/podcast-2.jpg": 1067,
	"./images/podcast-theme.jpg": 1068,
	"./images/polycycle.png": 1069,
	"./images/powerAndRenewables.jpg": 1070,
	"./images/pricolIcon.png": 1071,
	"./images/pricolIcon.svg": 1072,
	"./images/pricolImg.svg": 1073,
	"./images/profile.jpg": 1074,
	"./images/raqeeb.png": 187,
	"./images/raqeeb.svg": 1075,
	"./images/realtyCase.jpg": 1076,
	"./images/rhs_circle.svg": 224,
	"./images/right-arrow-with-lines.svg": 1077,
	"./images/riskPro.png": 188,
	"./images/roundImg1.svg": 241,
	"./images/roundImg2.svg": 242,
	"./images/rsm.png": 189,
	"./images/santhosh-jayaram.png": 167,
	"./images/screenshot-sample.svg": 1078,
	"./images/scribe.png": 200,
	"./images/sep2023-1.jpg": 1079,
	"./images/sep2023-11.jpg": 1080,
	"./images/september2024-1.jpg": 503,
	"./images/september2024-2.jpg": 504,
	"./images/september2024-3.jpg": 505,
	"./images/september2024-4.jpg": 506,
	"./images/september2024-5.jpg": 507,
	"./images/skyMax.jpg": 201,
	"./images/supplierAssessmentCase.jpg": 1081,
	"./images/suraksha.png": 190,
	"./images/suraksha.svg": 1082,
	"./images/switz_feb_2025.webp": 508,
	"./images/tanzania.svg": 1083,
	"./images/td-synnex.svg": 204,
	"./images/teknoSpec.png": 198,
	"./images/thailand.jpg": 509,
	"./images/thinkPlus.png": 191,
	"./images/thinkplus.svg": 1084,
	"./images/uae_map.svg": 1085,
	"./images/uk.jpg": 510,
	"./images/uk_map.svg": 1086,
	"./images/unkownUser.svg": 169,
	"./images/updapt-logo-green.png": 1087,
	"./images/updapt-logo-white.png": 1088,
	"./images/usa_map.svg": 1089,
	"./images/vDimension.jpeg": 203,
	"./images/view.png": 1090,
	"./images/view.svg": 1091,
	"./images/viewww.svg": 1092,
	"./images/wasteManagementCase.jpg": 1093,
	"./images/web-green-bg.svg": 1094,
	"./images/zest.png": 192,
	"./landing/AI & ML Driven Analytics.svg": 1095,
	"./landing/BA.svg": 1096,
	"./landing/ERM.svg": 1574,
	"./landing/Enterprise Level Collaboration.svg": 1097,
	"./landing/Global Reporting Standard.svg": 1098,
	"./landing/Interactive Dashboards.svg": 1099,
	"./landing/Net Zero.svg": 1100,
	"./landing/PE.svg": 1101,
	"./landing/SCM.svg": 1102,
	"./landing/Smart Emission Calculation.svg": 1103,
	"./landing/csrd_landing/csrdDashboard/csrd_dashboard_icon1.svg": 730,
	"./landing/csrd_landing/csrdDashboard/csrd_dashboard_icon2.svg": 731,
	"./landing/csrd_landing/csrdDashboard/csrd_dashboard_icon3.svg": 732,
	"./landing/csrd_landing/csrdDashboard/csrd_dashboard_img.svg": 655,
	"./landing/csrd_landing/csrdReport/csrd_report1.svg": 725,
	"./landing/csrd_landing/csrdReport/csrd_report2.svg": 726,
	"./landing/csrd_landing/csrdReport/csrd_report3.svg": 727,
	"./landing/csrd_landing/csrdReport/csrd_report4.svg": 728,
	"./landing/csrd_landing/csrdReport/csrd_report5.svg": 729,
	"./landing/csrd_landing/csrdReport/csrd_report_bg1.svg": 654,
	"./landing/csrd_landing/csrdReport/csrd_report_img3.svg": 653,
	"./landing/csrd_landing/csrdReport/csrd_report_img_1_2.svg": 652,
	"./landing/csrd_landing/csrd_banner.webp": 1104,
	"./landing/csrd_landing/csrd_updapt_logo.svg": 1105,
	"./landing/csrd_landing/csrddc/csrddc1.svg": 722,
	"./landing/csrd_landing/csrddc/csrddc2.svg": 723,
	"./landing/csrd_landing/csrddc/csrddc4.svg": 724,
	"./landing/csrd_landing/csrddc/csrddc_bg1.svg": 651,
	"./landing/csrd_landing/csrddc/csrddc_img1.svg": 648,
	"./landing/csrd_landing/csrddc/csrddc_img2.svg": 649,
	"./landing/csrd_landing/csrddc/csrddc_img3.svg": 650,
	"./landing/csrd_landing/dma/dm1.svg": 716,
	"./landing/csrd_landing/dma/dm2.svg": 717,
	"./landing/csrd_landing/dma/dm3.svg": 718,
	"./landing/csrd_landing/dma/dm4.svg": 719,
	"./landing/csrd_landing/dma/dm5.svg": 720,
	"./landing/csrd_landing/dma/dm6.svg": 721,
	"./landing/csrd_landing/dma/dma_stakeholder.svg": 647,
	"./landing/csrd_landing/faq_img_1.svg": 659,
	"./landing/csrd_landing/faq_img_2.svg": 660,
	"./landing/csrd_landing/minus-solid.svg": 740,
	"./landing/csrd_landing/plus-solid.svg": 739,
	"./landing/csrd_landing/section-2-image.svg": 1106,
	"./landing/csrd_landing/section_10_img.svg": 658,
	"./landing/csrd_landing/section_7_banner.svg": 656,
	"./landing/csrd_landing/section_9_banner.webp": 657,
	"./landing/csrd_landing/workSteps/steps_icon1.svg": 733,
	"./landing/csrd_landing/workSteps/steps_icon2.svg": 734,
	"./landing/csrd_landing/workSteps/steps_icon3.svg": 735,
	"./landing/csrd_landing/workSteps/steps_icon4.svg": 736,
	"./landing/csrd_landing/workSteps/steps_icon5.svg": 737,
	"./landing/csrd_landing/workSteps/steps_icon6.svg": 738,
	"./landing/new_landing_page_banner.svg": 1575,
	"./licencing/aa1000.svg": 637,
	"./licencing/cdp.svg": 641,
	"./licencing/global-goals.svg": 638,
	"./licencing/gri.svg": 643,
	"./licencing/panda.svg": 1576,
	"./licencing/pri.svg": 644,
	"./licencing/sasb.svg": 642,
	"./licencing/united-nations.svg": 639,
	"./licencing/wwf.svg": 640,
	"./pdf/April2021Newsletter.pdf": 512,
	"./pdf/April2022Newsletter.pdf": 513,
	"./pdf/August2021Newsletter.pdf": 514,
	"./pdf/August2022Newsletter.pdf": 515,
	"./pdf/December2020Newsletter.pdf": 516,
	"./pdf/December2021.pdf": 517,
	"./pdf/February2021Newsletter.pdf": 518,
	"./pdf/February2022Newsletter.pdf": 519,
	"./pdf/January2021Newsletter.pdf": 520,
	"./pdf/July2021Newsletter.pdf": 521,
	"./pdf/July2022Newsletter.pdf": 522,
	"./pdf/June2021Newsletter.pdf": 523,
	"./pdf/June2022Newsletter.pdf": 524,
	"./pdf/March2021Newsletter.pdf": 525,
	"./pdf/March2022Newsletter.pdf": 526,
	"./pdf/May2021Newsletter.pdf": 527,
	"./pdf/May2022Newsletter.pdf": 528,
	"./pdf/Newsletter - January2022.pdf": 529,
	"./pdf/November2020Newsletter.pdf": 530,
	"./pdf/November2021Newsletter.pdf": 531,
	"./pdf/October2021Newsletter.pdf": 532,
	"./pdf/September2021Newsletter.pdf": 533,
	"./pdf/September2022Newsletter.pdf": 534,
	"./pdf/media_november.pdf": 1107,
	"./platform/company.svg": 1577,
	"./platform/consultant.svg": 1578,
	"./platform/platform-illustration.png": 1579,
	"./platform/platform-illustration.svg": 1580,
	"./platform/platform-tick.svg": 1581,
	"./platform/service.svg": 1582,
	"./pricing/bespoke.svg": 692,
	"./pricing/premium.svg": 691,
	"./pricing/standard.svg": 690,
	"./productpage/advisory/uadvisory-header-bg.svg": 1583,
	"./productpage/advisory/uadvisory-illustrator.svg": 1584,
	"./productpage/advisory/uadvisory-mobile.svg": 1585,
	"./productpage/advisory/uadvisory-tick.svg": 1586,
	"./productpage/analytics/analytics-mobile.svg": 1587,
	"./productpage/analytics/uanalytics-header-bg.svg": 1588,
	"./productpage/analytics/uanalytics-illustrator.svg": 1589,
	"./productpage/analytics/uanalytics-tick.svg": 1590,
	"./productpage/datatrack/datatrack-mobile.svg": 1591,
	"./productpage/datatrack/datatrack-tick.svg": 1592,
	"./productpage/datatrack/udatatrack-header-bg.svg": 1593,
	"./productpage/datatrack/udatatrack-illustrator.svg": 1594,
	"./productpage/grant/grant-mobile.svg": 1595,
	"./productpage/grant/ugrant-header-bg.svg": 1596,
	"./productpage/grant/ugrant-illustrator.svg": 1597,
	"./productpage/grant/ugrant-tick.svg": 1598
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9;